<template>
  <div>
    <slot />
    <div v-show="!hide" class="wd-text-orange50 wd-m-0 wd-text-center wd-cursor-pointer wd-leading-8">
      <p :class="className" @click="toggleShowAll">{{ labelToggleText }}</p>
    </div>
  </div>
</template>

<script>
import { useVModel } from '@vueuse/core'

export default defineComponent({
  name: 'ContentShowMore',
  props: {
    modelValue: { type: Boolean, default: false },
    hide: { type: Boolean, default: false },
    className: { type: String, default: '' },
    textShow: { type: String, default: '' },
    textHide: { type: String, default: '' },
  },
  emits: ['change', 'update:modelValue'],
  setup(props, ctx) {
    const isShowAll = useVModel(props, 'modelValue', ctx.emit)
    const nuxtApp = useNuxtApp()
    const textShow = computed(() => props.textShow || nuxtApp.$i18n.t('show_all'))
    const textHide = computed(() => props.textHide || nuxtApp.$i18n.t('show_less'))
    const labelToggleText = computed(() => (isShowAll.value ? textHide.value : textShow.value))

    function toggleShowAll() {
      isShowAll.value = !isShowAll.value
      ctx.emit('change', isShowAll.value)
    }

    return {
      isShowAll,
      toggleShowAll,
      labelToggleText,
    }
  },
})
</script>

<style></style>
